import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Card from '../components/card'
import Footer from '../components/footer'
import './ui.css'

const Ui = (props) => {
  return (
    <div className="ui-container">
      <Helmet>
        <title>Ui - BharatKarade</title>
        <meta
          name="description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta property="og:title" content="Ui - BharatKarade" />
        <meta
          property="og:description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/37270ff6-c20f-4c60-89cf-ed199b10be0f/dec54fbc-2bef-42e2-a2f0-7c793b6d3599?org_if_sml=1"
        />
      </Helmet>
      <Header rootClassName="header-root-class-name6"></Header>
      <section className="ui-container1 Fade_in_up1">
        <span className="ui-text">Ui Arts</span>
        <div id="Grider" className="ui-container2">
          <a
            href="https://iili.io/HVxZlWb.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZlWb.png"
              Image_name="colloection ingame"
              image_name="colloection ingame"
              rootClassName="card-root-class-name42"
              className="ui-component01"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZczu.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZczu.png"
              Image_name="colloection mainmenue"
              image_name="colloection mainmenue"
              rootClassName="card-root-class-name43"
              className="ui-component02"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZYbe.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZYbe.png"
              Image_name="colloection store"
              image_name="colloection store"
              rootClassName="card-root-class-name44"
              className="ui-component03"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZ7e9.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZ7e9.jpg"
              Image_name="crafting weapons"
              image_name="crafting weapons"
              rootClassName="card-root-class-name45"
              className="ui-component04"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZ0sj.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZ0sj.jpg"
              Image_name="final collarage"
              image_name="final collarage"
              rootClassName="card-root-class-name46"
              className="ui-component05"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZEqx.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZEqx.jpg"
              Image_name="loading screen"
              image_name="loading screen"
              rootClassName="card-root-class-name47"
              className="ui-component06"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZMgV.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZMgV.jpg"
              Image_name="find the match"
              image_name="find the match"
              rootClassName="card-root-class-name48"
              className="ui-component07"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZG0Q.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZG0Q.jpg"
              Image_name="icon design"
              image_name="icon design"
              rootClassName="card-root-class-name49"
              className="ui-component08"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZWdB.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZWdB.jpg"
              Image_name="Introduction"
              image_name="Introduction"
              rootClassName="card-root-class-name50"
              className="ui-component09"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZX5P.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZX5P.png"
              Image_name="loading screen"
              image_name="loading screen"
              rootClassName="card-root-class-name51"
              className="ui-component10"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZhe1.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZhe1.png"
              Image_name="logo final coloreing"
              image_name="logo final coloreing"
              rootClassName="card-root-class-name52"
              className="ui-component11"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZNzg.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZNzg.png"
              Image_name="logo red rection"
              image_name="logo red rection"
              rootClassName="card-root-class-name99"
              className="ui-component12"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZOXa.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZOXa.jpg"
              Image_name="Poker Menu"
              image_name="Poker Menu"
              rootClassName="card-root-class-name98"
              className="ui-component13"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZ81R.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZ81R.jpg"
              Image_name="Process"
              image_name="Process"
              rootClassName="card-root-class-name97"
              className="ui-component14"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZvqv.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZvqv.jpg"
              Image_name="Rewards"
              image_name="Rewards"
              rootClassName="card-root-class-name96"
              className="ui-component15"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZeLJ.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZeLJ.jpg"
              Image_name="sense of death logo"
              image_name="sense of death logo"
              rootClassName="card-root-class-name95"
              className="ui-component16"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZSgp.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZSgp.jpg"
              Image_name="settings"
              image_name="settings"
              rootClassName="card-root-class-name94"
              className="ui-component17"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZgdN.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZgdN.jpg"
              Image_name="Special offer"
              image_name="Special offer"
              rootClassName="card-root-class-name93"
              className="ui-component18"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZr7I.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZr7I.jpg"
              Image_name="Special offer 01"
              image_name="Special offer 01"
              rootClassName="card-root-class-name92"
              className="ui-component19"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZ4et.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZ4et.jpg"
              Image_name="splash"
              image_name="splash"
              rootClassName="card-root-class-name91"
              className="ui-component20"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZ6mX.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZ6mX.jpg"
              Image_name="UI RTS"
              image_name="UI RTS"
              rootClassName="card-root-class-name90"
              className="ui-component21"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZt14.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZt14.png"
              Image_name="zing poker inGame 22june 5"
              image_name="zing poker inGame 22june 5"
              rootClassName="card-root-class-name89"
              className="ui-component22"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZiIn.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZiIn.jpg"
              Image_name="01 Navigation pop up Castle"
              image_name="01 Navigation pop up Castle"
              rootClassName="card-root-class-name88"
              className="ui-component23"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZsXs.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZsXs.jpg"
              Image_name="02 Navigation pop up LAB"
              image_name="02 Navigation pop up LAB"
              rootClassName="card-root-class-name87"
              className="ui-component24"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZZBf.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZZBf.jpg"
              Image_name="03 Navigation pop up Barracks"
              image_name="03 Navigation pop up Barracks"
              rootClassName="card-root-class-name86"
              className="ui-component25"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZDrl.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZDrl.jpg"
              Image_name="04 Navigation pop up Sword"
              image_name="04 Navigation pop up Sword"
              rootClassName="card-root-class-name85"
              className="ui-component26"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZm22.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZm22.jpg"
              Image_name="1660038007631"
              image_name="1660038007631"
              rootClassName="card-root-class-name83"
              className="ui-component27"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxZyk7.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxZyk7.jpg"
              Image_name="1660038008573"
              image_name="1660038008573"
              rootClassName="card-root-class-name82"
              className="ui-component28"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxt9p9.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxt9p9.png"
              Image_name="all collections"
              image_name="all collections"
              rootClassName="card-root-class-name81"
              className="ui-component29"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxtJIe.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxtJIe.jpg"
              Image_name="attack animi"
              image_name="attack animi"
              rootClassName="card-root-class-name80"
              className="ui-component30"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxtdhu.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxtdhu.jpg"
              Image_name="Castle to anim direction anim"
              image_name="Castle to anim direction anim"
              rootClassName="card-root-class-name79"
              className="ui-component31"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxt2Lb.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxt2Lb.jpg"
              Image_name="challenges"
              image_name="challenges"
              rootClassName="card-root-class-name78"
              className="ui-component32"
            ></Card>
          </a>
        </div>
      </section>
      <Footer rootClassName="footer-root-class-name6"></Footer>
    </div>
  )
}

export default Ui
